const thrpyDocumentType = {
  UnSet: 0,
  CartaDeAprestacionDeRemedio: -1,
  PlanDeIntervencion: 844,
  PlanDeEnmienda: 862,
  PaquetePlanAnual: 863,
  ResumenResultadoDeServicios: 872,
  CodeDocumentTypeResumenResultadosServicios: 86,
  Minuta: 857,
  ThrpyEvaluacion: 856,
  Evaluacion: 75,
  Otros: 858,
  PlanDeIntervencionRP: 39,
  InformeDeProgresoRP: 40,
  HojaDeAsistenciaRP: 41,
  OtrosRP: 37,
};

export default thrpyDocumentType;
